// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uCdZF","toggle":"styles_toggle__Q9Ehi","preview":"styles_preview__1x2e7"};